import { Box } from '@mui/material'

import { CollaboratorCard } from './CollaboratorCard'

export const Collaborators = ({ collaborators = [], isPreview, gap = 1, waypointUsers = [] }) => (
  <Box
    display="flex"
    flexDirection="column"
    gap={gap}
    mt={2}
  >
    {collaborators.map((collaborator) => (
      <CollaboratorCard
        collaborator={collaborator}
        isPreview={isPreview}
        key={collaborator.user_id}
        waypointUsers={waypointUsers}
      />
    ))}
  </Box>
)
